module.exports = __webpack_public_path__ + "img/dettaglio bagno.aab705fb.jpeg";